// src/app/store.js

import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production'
      ? { name: 'MyApp', trace: true, traceLimit: 25 }
      : false,
  });


  export default store